import { Trans } from '@lingui/macro'
import { NavigateBefore, NavigateNext, SaveAlt, SaveSharp } from '@mui/icons-material'
import { Grid } from '@mui/material'
import { ButtonIcon } from 'app/views/common-components/ButtonIcon'
import { ShrinkableButton } from 'app/views/common-components/ShrinkableButton'
import { downloadOrphanedPDF } from '../pdf-components/formPdfUtils'

export const StepperButtons = ({
  activeStep,
  noStepper,
  handleBack,
  handleSave,
  handleNext,
  generatePDF,
  showPDFButton,
  formTitle,
  saving,
  disableSave,
  muBag,
  hideSaveButton,
  steps,
  printRef,
  elementsMap,
  disablePDFDownload,
  showNavigation = true,
  useMultiuser,
  renderDropdown,
  renderShrink,
  extraButtons = []
}) => {
  const downloadPdf = () => {
    document.body.style.cursor = 'wait'
    const pdfDocument = generatePDF({ shouldCalculateFixedElementsInHook: false })
    downloadOrphanedPDF(pdfDocument, formTitle)
  }

  return (
    <Grid
      container
      style={{ marginLeft: 'auto', marginTop: (renderDropdown || renderShrink) && '16px' }}
      wrap='nowrap'
      justifyContent='flex-end'
      gap='16px'
    >
      {!noStepper && showNavigation && activeStep !== 0 && (
        <ShrinkableButton
          variant='contained'
          color='secondary'
          disabled={activeStep === 0}
          onClick={handleBack}
          shrink={renderShrink}
          icon={<ButtonIcon IconClass={NavigateBefore} left />}
          text={<Trans>Previous</Trans>}
        />
      )}
      {!hideSaveButton && (
        <ShrinkableButton
          variant='contained'
          color='primary'
          disabled={saving || disableSave}
          onClick={handleSave}
          shrink={renderShrink}
          icon={<ButtonIcon IconClass={SaveSharp} />}
          text={<Trans>Save</Trans>}
        />
      )}

      {showPDFButton && (
        <ShrinkableButton
          variant='outlined'
          color='primary'
          onClick={downloadPdf}
          disabled={disablePDFDownload}
          shrink={renderShrink}
          icon={<ButtonIcon IconClass={SaveAlt} />}
          text={<Trans>FORM_DOWNLOAD_PDF</Trans>}
        />
      )}
      {/* {useMultiuser && (
        <FormBackupsPanel
          elementsMap={elementsMap}
          saving={saving}
          muBag={muBag}
        />
      )} */}

      {extraButtons.map((renderButton, index) => (
        renderButton(renderShrink, index)
      ))}

      {!noStepper && showNavigation && activeStep !== steps.length - 1 && (
        <ShrinkableButton
          variant='outlined'
          color='primary'
          disabled={activeStep === steps.length - 1}
          onClick={handleNext}
          shrink={renderShrink}
          icon={<ButtonIcon IconClass={NavigateNext} />}
          text={<Trans>Next</Trans>}
        />
      )}
    </Grid>
  )
}
